import TabNav from 'components/TabNav/TabNav';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import usePermission from 'hooks/usePermission';
import useSurveysAccess from '../../../extensions/surveys/hooks/useSurveysAccess';
import css from './LayoutSideNavigation.module.css';

const TabNavOrganisation = ({ currentPage }) => {
  const isQuestionsVisible = useSurveysAccess() === 'allowed';
  const isRegisterVisible = usePermission('write:configs.registers') === 'allowed';
  const isApiKeysVisible = usePermission('read:organisation.api-keys') === 'allowed';

  const tabs = useMemo(
    () => [
      {
        text: <FormattedMessage id="TabNavOrganisation.settingsTabTitle" />,
        selected: currentPage === 'OrganisationPage',
        id: 'OrganisationPageTab',
        linkProps: {
          name: 'OrganisationPage',
        },
      },
      {
        text: <FormattedMessage id="TabNavOrganisation.paymentsTabTitle" />,
        selected: currentPage === 'OrganisationPaymentsPage',
        id: 'OrganisationPaymentsPageTab',
        linkProps: {
          name: 'OrganisationPaymentsPage',
        },
      },
      {
        text: <FormattedMessage id="TabNavOrganisation.membersTabTitle" />,
        selected: currentPage === 'OrganisationMembersPage',
        id: 'OrganisationMembersPageTab',
        linkProps: {
          name: 'OrganisationMembersPage',
        },
      },
      ...(isQuestionsVisible
        ? [
            {
              text: <FormattedMessage id="TabNavOrganisation.questionsTabTitle" />,
              selected: currentPage === 'OrganisationQuestionsPage',
              id: 'OrganisationQuestionsPageTab',
              linkProps: {
                name: 'OrganisationQuestionsPage',
              },
            },
          ]
        : []),
      ...(isRegisterVisible
        ? [
            {
              text: <FormattedMessage id="TabNavOrganisation.registerTabTitle" />,
              selected: currentPage === 'OrganisationRegisterPage',
              id: 'OrganisationRegisterPageTab',
              linkProps: {
                name: 'OrganisationRegisterPage',
              },
            },
          ]
        : []),
      ...(isApiKeysVisible
        ? [
            {
              text: <FormattedMessage id="TabNavOrganisation.apiKeysTabTitle" />,
              selected: currentPage === 'OrganisationApiKeysPage',
              id: 'OrganisationApiKeysPageTab',
              linkProps: {
                name: 'OrganisationApiKeysPage',
              },
            },
          ]
        : []),
    ],
    [currentPage, isQuestionsVisible, isRegisterVisible, isApiKeysVisible]
  );

  return <TabNav rootClassName={css.tabs} tabRootClassName={css.tab} tabs={tabs} />;
};

export default TabNavOrganisation;
